import type EnType from '../en-US/project';

export default {
  'projectDetail.label.lookDetailButton': 'Ver Detalhes',
} satisfies typeof EnType;
